import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FooterBlockComponent } from "./FooterBlock";
import { defaultData } from "./FooterBlockDefaultData";
import { meta } from "./FooterBlockMetaData";

export const FooterBlock: BlockExport = {
  type: "component",
  Block: FooterBlockComponent,
  defaultData,
  meta,
};
